import { Form, Formik } from 'formik';
import { Props, Values } from './ResetPasswordForm.types';
import * as Yup from 'yup';
import FormField from '../../components/field/FormField';
import Button from '../../components/button/Button';

const _initialValues: Values = {
  email: '',
  password: '',
  confirmPassword: '',
};

/**
 * A component represents reset password form
 * @param onSubmit function for handling the submitted form
 * @param initialValues initial/default values for the form
 */
export const ResetPasswordForm = ({ onSubmit, initialValues }: Props) => {
  const SignupSchema = Yup.object().shape({
    email: Yup.string().email('E-mail is invalid').required('E-mail is required.'),
    password: Yup.string()
      .required('Password is required.')
      .min(6, 'The password must be at least 6 characters long.')
      .max(100, 'The password can have a max of 100 characters.')
      .matches(
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[\d])(?=.*?[^\w\s]).{6,100}$/,
        'Passwords must have at least one a special character, at least one digit and at least one uppercase character.',
      ),
    confirmPassword: Yup.string()
      .required('Password confirmation is required.')
      .when('password', {
        is: (value: string) => value && value.length > 0,
        then: Yup.string().oneOf([Yup.ref('password')], 'Entered passwords must be the same'),
      }),
  });

  return (
    <Formik
      initialValues={initialValues || _initialValues}
      onSubmit={onSubmit}
      validationSchema={SignupSchema}
    >
      {({ errors, touched }) => (
        <Form>
          <div className="my-4">
            <FormField
              id="email"
              name="email"
              label="E-mail"
              type="email"
              errors={errors}
              touched={touched}
            />
          </div>

          <div className="my-4">
            <FormField
              id="password"
              name="password"
              type="password"
              label="Password"
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <FormField
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              label="Confirm password"
              errors={errors}
              touched={touched}
            />
          </div>
          <Button type="submit" title="Reset password" fullWidth />
        </Form>
      )}
    </Formik>
  );
};
